import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getComments, getCourseReviews, getMyCourses, getNotes } from "../../service/endpoints";

export const myCourseHandler = createAsyncThunk('myCourseHandler', async (data) => {
    try {
        const response = await getMyCourses(data)
        console.log(response.data,'my-course')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
 })

export const myNotesHandler = createAsyncThunk('myNotesHandler',async (data)=>{

    try {
        const response = await getNotes(data);
        console.log("my-notes",response.data);
        return response.data

    } catch (error) {
        if (error.response !== undefined) {
            console.log('fail', error)
            throw error.response
        }
        else {
            console.log(error)
            throw error.response
        }
    }
});

export const commentsHandler = createAsyncThunk('commentsHandler',async (data)=>{
    try {
        const response = await getComments(data);
        console.log("comments",response.data);
        return response.data

    } catch (error) {
        if (error.response !== undefined) {
            console.log('fail', error)
            throw error.response
        }
        else {
            console.log(error)
            throw error.response
        }
    }
})

export const ratingsHandler = createAsyncThunk('ratingsHandler',async (data)=>{
    try {
        const response = await getCourseReviews(data.courseId,data.videoId);
        console.log("ratings",response.data);
        return response.data

    } catch (error) {
        if (error.response !== undefined) {
            console.log('fail', error)
            throw error.response
        }
        else {
            console.log(error)
            throw error.response
        }
    }
})


const MyCourseSlice = createSlice({
    name: 'My_course',
    initialState: {
        isLoading: false,
        data: null,
        isError: false,
        notes: [],
        comments:[],
        ratings: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(myCourseHandler.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(myCourseHandler.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(myCourseHandler.rejected, (state) => {
                state.isError = true;
            })
            .addCase(myNotesHandler.fulfilled, (state, action) => {
                state.isLoading = false;
                console.log("my notes fulfilled",action.payload)
                state.notes = action.payload; // Update notes in the state
            })
            .addCase(myNotesHandler.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(myNotesHandler.rejected, (state) => {
                state.isError = true;
            })
            .addCase(commentsHandler.fulfilled, (state, action) => {
                state.isLoading = false;
                state.comments = action.payload;
            })
            .addCase(commentsHandler.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(commentsHandler.rejected, (state) => {
                state.isError = true;
            })
            .addCase(ratingsHandler.fulfilled,(state,action)=>{
                state.isLoading = false;
                state.ratings = action.payload
            })
            .addCase(ratingsHandler.pending,(state,action)=>{
                state.isLoading = true;
            })
            .addCase(ratingsHandler.rejected,(state,action)=>{
                state.isLoading = false;
                state.isError = true;
            })
        },
});

export default MyCourseSlice.reducer;
